import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgMinus = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    ref={ref}
    {...props}
  >
    <path
      fill="#FAFAFA"
      d="M17.5 10.5a.625.625 0 0 1-.625.625H3.125a.625.625 0 0 1 0-1.25h13.75a.625.625 0 0 1 .625.625"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
